<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #modal-print,
  #modal-print * {
    visibility: visible;
  }

  #modal-print {
    position: absolute;
    inset: 0;
    background: white !important;
  }
}
</style>
<template>
  
  <!-- Fondo semitransparente -->
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 bg-black/50 backdrop-blur-sm
         flex items-center justify-center z-50 p-6">
      <!-- Modal -->
      <div class="bg-white  w-full   max-w-2xl  p-5 transform transition-all flex flex-col overflow-hidden">

        <div class="flex justify-start ">
          <span
            class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalAgregarCtaBorrador&#62;</span>
        </div>

        <!-- ================= HEADER ================= -->
        <div class="border-b p-5 flex justify-between items-start shrink-0">

          <div class="flex-1 text-center space-y-3">
            <h2 class="text-xl font-semibold font-mono text-gray-800  ">
              Cuentas para agregar a presupuesto año  {{this.$store.state.auth.userLogin.año_borrador}}
            </h2>
          </div>

          <button @click="cerrar" class="text-gray-400 hover:text-gray-600 transition text-2xl leading-none ml-4">
            ✕
          </button>
        </div>

        <!-- ================= CONTENIDO SCROLL ================= -->
        <div class="flex-1 overflow-y-auto">

          <div v-if="centro_cuentas.length == 0" class=" px-6 py-4 border-b flex justify-between items-center">

            <p class="text-sm text-red-800 font-mono mt-3 ">
 
            </p>
          </div>
          <div     class="mb-10 bg-white shadow-lg rounded-2xl border border-gray-200 overflow-hidden">

            <!---
             {
              "id": 94, 
              "cod": "1212103006", 
              "nomcta": "Equipamiento", 
              "total_presupuesto": 0, 
              "total_presupuesto_borrador": 0, 
              "tipo_id": 22, 
              "total_gastos": 0, 
              "visible": false 
            }
            -->
            
           
            <!-- Tabla -->
            <div class="overflow-x-auto">
             <table class="w-full text-sm" v-if="tipo_ctas?.length">

                <!-- Header tabla -->
                <thead class="bg-gray-100 text-gray-700 uppercase text-xs tracking-wider">
                  <tr>

                    
                    <th class="px-4 py-3 text-center">Codigo</th>
                    <th class="px-4 py-3 text-center">Nombre</th>
                    <th class="px-4 py-3 text-right"></th>
                     
                  </tr>
                </thead>


                <!-- Body -->
                <tbody>

                  <tr v-for="p in tipo_ctas " :key="p.id"
                    class="border-t hover:bg-gray-50 transition font-mono">


                   
                    <td class="px-4 py-2 font-medium text-gray-700">
                      {{ p.cod }}
                    </td>

                    <td class="px-4 py-2 text-left font-mono">
                      {{ p.nomcta}}
                    </td>

                    <td class="px-4 py-2 text-left font-mono">
                      <span v-if="!p.visible" @click="addCta(p.id)">+ Agregar</span> 
                    </td>

         
 

                  </tr>

                </tbody>
            
              </table>

            </div>
           

           

          </div>


        </div>

        <!-- ================= FOOTER ================= -->
        <div class="border-t p-4 flex justify-end space-x-4
             text-sm text-gray-600 shrink-0">
         
          <button @click="cerrar" class="bg-gray-300 hover:bg-gray-200 text-gray-900
               px-6 py-2 rounded-lg shadow-sm">
            Cerrar ventana
          </button>
          
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
 
export default {
  name: "ModalAgregarCtaBorrador",
  emits:['visibilizaCta'],
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    tipo_ctas: {
      type: Array,
    },
    timestamp: {
      type: String,
    },
    tipo_id: {
      type: Number
    },
     
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
    nombreMes() {
      const fecha = new Date()

      const mes = new Intl.DateTimeFormat("es-CL", {
        month: "long"
      }).format(fecha)

      return mes.charAt(0).toUpperCase() + mes.slice(1)
    }
  },

  watch: {

    timestamp: function () {
      // this.recargaDatos(this.datosModificacion);
    },
    centro_responsable_cuentas: function (v) {
      this.centro_cuentas = v;
      this.agregaNombres();

    },


  },
  methods: {

    cerrar() {
      this.$emit("update:visible", false);
    },
    addCta(cta_id){
     
          this.$emit("visibilizaCta", cta_id);
            this.$emit("update:visible", false);
    },
    async cargarGastos() {
      this.loading = true
      try {

        const promesas = this.centro_cuentas.map(async centro => {
          centro.detalle = await this.leeGastosFecha(centro.id)
          return centro
        })
        await Promise.all(promesas)

      } finally {

        this.loading = false

      }
    },
   
      
  },
  data() {
    return {
      loading: false,
      ingresos: [],
      modificaciones: [],
      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],

      mes: 0,
      nomcentro: "",
      nomcta: "",
      nommes: " ",

      centro_id: 0,
      cuenta_id: 0,
      centro_cuentas: [],
      saldo: 0,
      DJANGO_APP_API_URL: '',
      ultimo_id_modificacion: 0,
      cuentas: [],
      año: '',
      descripcion_libromayor: '',
      clasificaciones: [],
      nomSelectedCuenta: '',
      nomCentro: ''
    };
  },
  mounted() {
    console.log('mounted!');
    this.DJANGO_APP_API_URL = process.env.VUE_APP_DJANGO_API_URL
    this.clasificaciones = JSON.parse(process.env.VUE_APP_CLASIF_CENTRO)
 
  },
};
</script>
